import { A11yModule } from '@angular/cdk/a11y';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthDrawerComponent } from 'src/app/components/auth-drawer/auth-drawer.component';
import { IconModule } from 'src/app/icon/icon.module';
import { MaterialModule } from 'src/app/material.module';
import { AuthService } from 'src/app/services/auth.service';
import { ToastService } from 'src/app/services/toast.service';
import { PATTERN, ROUTES } from 'src/app/shared/constants';

// Rendered in the login page's drawer outlet (/register)
@Component({
  selector: 'app-register',
  imports: [A11yModule, ReactiveFormsModule, TranslateModule, IconModule, MaterialModule, AuthDrawerComponent],
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  spinLoader = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.registerForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.pattern(PATTERN.EMAIL)]]
    });
  }

  isInvalid(key: string) {
    const control = this.registerForm.get(key);
    return !!control && control.invalid && control.touched;
  }

  hasError(key: string, errorType: string) {
    return !!this.registerForm.get(key)?.hasError(errorType);
  }

  onSubmit() {
    if (!this.registerForm.valid) {
      this.registerForm.markAllAsTouched();
    } else {
      this.spinLoader = true;
      const redirectUrl = `${window.location.origin}/reset-password`;
      this.authService.register(this.registerForm.value, redirectUrl).subscribe({
        next: () => {
          const toastMsg = 'registration successfully';
          this.toastService.success(this.translateService.instant(toastMsg))
          this.close();
        },
        error: ({ error, status }) => {
          this.spinLoader = false;
          if (!error) return;

          if (status === 400 && error.errors?.length) {
            const firstError = error.errors[0];
            if (!firstError) return;
            const { field, error: errorMessage } = firstError;
            const message = `${this.translateService.instant(field.toLowerCase())} ${this.translateService.instant(errorMessage)}`;
            this.toastService.error(message);
          } else if (status === 429 && error.Message) {
            this.toastService.warning(this.translateService.instant(error.Message), undefined, { timeOut: 5000 });
          } else if (error.Message || error.message) {
            this.toastService.error(this.translateService.instant(error.Message || error.message));
          }
        }
      });
    }
  }

  close() {
    this.router.navigate([ROUTES.USER.LOGIN]);
  }
}
